import { LoadingStyled } from "./styles"

import loadingIcon from "../../assets/imgs/loading_icon.svg"

export const Loading = () => {

    return (
        <LoadingStyled>
            <img src={loadingIcon} alt="loading" />
        </LoadingStyled>
    )
}